import React from "react";
import useDebugInformation from "../../../../hooks/useDebugInformation";
import { state } from "../../../../interfaces/interfaces";
import Five9CompactStatus from "./Five9CompactStatus";
import {
	useFive9BookingLogic,
	useFive9Integration,
	useFive9Subscriptions,
} from "./hooks";

type Five9StateProps = {};

const Five9State: React.FC<Five9StateProps> = () => {
	// Get all Five9 subscription state via custom hook
	const five9State = useFive9Subscriptions();

	// Initialize Five9 integration
	const { isInitialized } = useFive9Integration();

	// Handle booking creation logic via custom hook
	useFive9BookingLogic(five9State);

	// Debug information
	useDebugInformation("Five9State", {
		state,
		...five9State,
		isInitialized,
	});

	// Render Five9 Compact Status UI
	return <Five9CompactStatus />;
};

Five9State.displayName = "Five9State";

export default React.memo(Five9State);
